import { FormatTimeUom } from './types'

// export const THROTTLE_UOM_FORMAT = [
//     { value: FormatTimeUom.ms, unit: 1 },
//     { value: FormatTimeUom.s, unit: 1000 },
//     { value: FormatTimeUom.m, unit: 1000 * 60 },
//     { value: FormatTimeUom.h, unit: 1000 * 60 * 60 },
//     { value: FormatTimeUom.d, unit: 1000 * 60 * 60 * 24 }
// ]

export const THROTTLE_UOM_FORMAT = {
    [FormatTimeUom.ms]: 1,
    [FormatTimeUom.s]: 1000,
    [FormatTimeUom.m]: 1000 * 60,
    [FormatTimeUom.h]: 1000 * 60 * 60,
    [FormatTimeUom.d]: 1000 * 60 * 60 * 24
} as {
    [format: string]: number
}

// SET DEFAULT THROTTLE UNIT AS MINUTES
export const defaultThrottleUOMUnit = getThrottleUOMUnit(FormatTimeUom.m)

// SET DEFAULT THROTTLE VALUE AS 1800MS (3MINUTES)
export const defaultThrottleValue = THROTTLE_UOM_FORMAT[FormatTimeUom.m] * 3

export function getThrottleUOMLabel(value: FormatTimeUom): string {
    switch (value) {
        case FormatTimeUom.ms:
            return 'millisecond(s)'
        case FormatTimeUom.s:
            return 'second(s)'
        case FormatTimeUom.m:
            return 'minute(s)'
        case FormatTimeUom.h:
            return 'hour(s)'
        case FormatTimeUom.d:
            return 'day(s)'
    }
}

export function getOptionsUOMSelector() {
    return Object.values(FormatTimeUom).map((v, u) => {
        return {
            value: v,
            label: getThrottleUOMLabel(FormatTimeUom[v])
        }
    })
}

export function getThrottleUOMUnit(value: string) {
    if (!isValidUomUnit(value)) return undefined
    return FormatTimeUom[value]
}

export function isValidUomUnit(uomString: string): boolean {
    return uomString !== undefined && uomString.trim() != "" &&
        Object.keys(FormatTimeUom).filter(x => !(parseInt(x) >= 0)).includes(uomString)
}

export function parseFormatTimeUom(value: number, format: FormatTimeUom, baseFormat: FormatTimeUom): number {
    if (value === undefined || Number.isNaN(value) || !isValidUomUnit(format)) return undefined
    return value * THROTTLE_UOM_FORMAT[format]
}

export function parseMillisecondsToUOM(value: number, format: FormatTimeUom, baseFormat: FormatTimeUom): number {
    if (value === undefined || !Number.isInteger(value) || Number.isNaN(value)) return undefined
    return parseFloat((value / THROTTLE_UOM_FORMAT[format]).toFixed(3))
}
